import { Injectable } from '@angular/core';
import { ApplicationInsights, SeverityLevel } from '@microsoft/applicationinsights-web';
import { environment } from '@env/environment';

@Injectable({ providedIn: 'root' })
export class AppInsightsService {
  private appInsights: ApplicationInsights | null = null;

  private getClient(): ApplicationInsights | null {
    if (!environment.appInsightsKey) {
      return null;
    }
    if (!this.appInsights) {
      this.appInsights = new ApplicationInsights({
        config: { instrumentationKey: environment.appInsightsKey }
      });
      this.appInsights.loadAppInsights();
    }
    return this.appInsights;
  }

  trackTrace(message: string, properties?: { [key: string]: unknown }): void {
    this.getClient()?.trackTrace({ message, properties });
  }

  trackException(
    error: Error,
    _id: unknown,
    properties?: { [key: string]: unknown },
    _measurements?: unknown,
    severityLevel?: SeverityLevel
  ): void {
    this.getClient()?.trackException({ exception: error, properties, severityLevel });
  }
}
